import React, { FC, ReactNode } from 'react';
import { Stack, StackItem, TabContent } from '@patternfly/react-core';
import { Route, Switch } from 'react-router-dom';
import AccountNav from './Nav/AccountNav';
import ComponentLoader from '../General/ComponentLoader/ComponentLoader';
import Env from '../../utils/env';

const AccountDetails = () => {
  const AccountWrapper: FC<{
    id: string;
    children: ReactNode;
    tabName: string;
  }> = ({ children, id, tabName }) => {
    return (
      <TabContent
        id={id}
        aria-label={tabName}
        data-analytics-category={`Account Details|Tabs|${tabName}`}>
        {children}
      </TabContent>
    );
  };
  return (
    <Stack>
      <StackItem>
        <AccountNav />
      </StackItem>
      <StackItem className="app-content">
        <Switch>
          <Route exact={true} path={Env.routePrefix + "/my-profile"}>
            <AccountWrapper id="my-profile" tabName="My Profile">
              <ComponentLoader componentName="MyProfile" />
            </AccountWrapper>
          </Route>
          <Route exact={true} path={Env.routePrefix + "/company-profile"}>
            <AccountWrapper id="company-profile" tabName="Company Profile">
              <ComponentLoader componentName="CompanyProfile" />
            </AccountWrapper>
          </Route>
          <Route exact={true} path={Env.routePrefix + "/team-members"}>
            <AccountWrapper id="team-members" tabName="Team Members">
              <ComponentLoader componentName="TeamMembers" />
            </AccountWrapper>
          </Route>
          <Route exact={true} path={Env.routePrefix + "/agreements"}>
            <AccountWrapper id="agreements" tabName="Agreements">
              <ComponentLoader componentName="Agreements" />
            </AccountWrapper>
          </Route>
          <Route exact={true} path={Env.routePrefix + "/api-keys"}>
            <AccountWrapper id="api-keys" tabName="API keys">
              <ComponentLoader componentName="KeyManager" />
            </AccountWrapper>
          </Route>
        </Switch>
      </StackItem>
    </Stack>
  );
};

export default AccountDetails;
